// extracted by mini-css-extract-plugin
export var benefit = "benefitsgrid-module--benefit--TYYFq";
export var benefitDescription = "benefitsgrid-module--benefitDescription--e97hl";
export var benefitIcon = "benefitsgrid-module--benefitIcon--ZMnv5";
export var benefitTitle = "benefitsgrid-module--benefitTitle--oCGD6";
export var benefitsContainer = "benefitsgrid-module--benefitsContainer--aFYMd";
export var benefitsGridParent = "benefitsgrid-module--benefitsGridParent--lxVZN";
export var benefitsRow = "benefitsgrid-module--benefitsRow--r6Mu6";